import React, { useState, useEffect } from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useMap } from 'react-map-gl';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
 
import { callGetJson } from '../api/jsonConfApi';
import { openModal } from '../store/actions/modalActions';
import { useResponsive } from '../hooks/useResponsive';

export const ZoomZoneButton = () => {

  const { i18n, t } = useTranslation();
  const getLanguage = () => i18n.language || window.localStorage.i18nextLng;
  const {mymap} = useMap();
  const { isMobile } = useResponsive();

  const [zoomConf, setZoomConf] = useState([]);
  const [zoomByZone, setZoomByZone] = useState({});
  const [value, setValue] = useState('');
  const dispatch = useDispatch();


  useEffect(() => {
    callGetJson('custom_zoom_zone_button.json').then(
      result => {
        setZoomConf(result);
        setZoomByZone(Object.assign({}, ...result.map((x) => ({[x.zone]: x}))));
      });
    return () => {
      setZoomConf([]);
      setZoomByZone({});
    };
  }, []);

  const handleChange = (event) => {
    const key = event.target.value;
    setValue(key);
    mymap.flyTo({center: zoomByZone[key].center, zoom: zoomByZone[key].zoom, duration: 500});
    let zoneDes = zoomByZone[key].textFrDesc;
    let imageDes = zoomByZone[key].imageFRDesc;
    if (getLanguage()==='fr') {
      zoneDes = zoomByZone[key].textFrDesc;
      imageDes = zoomByZone[key].imageFRDesc;
    } else if (getLanguage()==='en') {
      zoneDes = zoomByZone[key].textEnDesc;
      imageDes = zoomByZone[key].imageENDesc;
    } else if (getLanguage()==='es') {
      zoneDes = zoomByZone[key].textEsDesc;
      imageDes = zoomByZone[key].imageESDesc;
    }
    dispatch(openModal(key, zoneDes, zoomByZone[key].image, zoomByZone[key].credits, imageDes));
  };


  return (
    
    <FormControl size={'medium'} fullWidth>
      <InputLabel 
        color='zone'
        id="zoom-control-select-label"
      >
        {t('zoomButton.label')}
      </InputLabel>
      <Select
        labelId="zoom-control-select-label"
        id="zoom-control-select"
        label={t('zoomButton.label')}
        value={value}
        onChange={handleChange}
        onBlur={() => setValue('')}
        color='zone'
        variant='outlined'
        sx={{
          display: 'flex',
          backgroundColor: 'white',
          borderRadius: '0.5em',
          minWidth: isMobile ? 150 :  180,
        }}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                color: 'zone.main',
              },
            },
          },
        }}
      >
        {zoomConf.map((conf) => {
          return (
            <MenuItem 
              key={conf.zone} 
              value={conf.zone} 
              sx={{
                whiteSpace: 'pre-line'
              }}
            >
              {conf.zone}
            </MenuItem>
          );
        }
        )
        }
        
      </Select>
    </FormControl>
  );
};